import { APP_VER } from 'app/core/config';
import axios from 'axios';
import * as semver from 'semver';

import { setSession } from '../../services/jwtService';
import { FILE_UPLOADS_URL, VIMEO_UPLOADS_URL } from '../file-upload';
import { prepareResponseData } from '../helpers/prepareResponseData';

const checkHeaders = (headers: any) => {
  if (headers && headers['x-app-version']) {
    const event = new CustomEvent('versionCheck', {
      detail: { isMatch: semver.gte(APP_VER, headers['x-app-version']) },
    });
    document.dispatchEvent(event);

    // AUTO RELOAD ALTERNATIVE
    // if (!semver.gte(APP_VER, headers['x-app-version'])) {
    //   window.location.reload();
    // }
  }
};

export const registerResponseInterceptor = () => {
  axios.interceptors.response.use(
    function (response) {
      // exeptions - presign url to AwsS3 upload
      if (
        response.config.url === FILE_UPLOADS_URL ||
        response.config.url === VIMEO_UPLOADS_URL
      ) {
        return response;
      }
      checkHeaders(response.headers);

      return { ...response, data: prepareResponseData(response.data) };
    },
    (err) => {
      return new Promise((resolve, reject) => {
        if (
          err.response &&
          err.response.status === 401 &&
          err.config &&
          !err.config.__isRetryRequest
        ) {
          // if you ever get an unauthorized response, logout the user
          setSession(null);
        }
        throw err;
      });
    }
  );
};
